import { defineComponent, ref, nextTick, computed, onMounted } from '@vue/composition-api';
import LabelAPI from 'src/api/labels';
import ProjectLabel from 'src/components/site/ProjectLabels/ProjectLabel.vue';
export default defineComponent({
    components: {
        ProjectLabel,
    },
    props: {
        showIcon: { type: Boolean, default: false },
        projectId: { type: Number, default: undefined },
        currentLabels: { type: Array, default: () => [] },
    },
    setup(props, { emit }) {
        const inputHidden = ref(true);
        const hidePlus = ref(false);
        const inputElm = ref(null);
        const isFetching = ref(true);
        const labels = ref([]);
        const nMore = ref(0);
        const newLabel = ref(undefined);
        const currentLabelIds = computed(() => props.currentLabels.map((l) => l.id));
        const fetchLabels = async (q) => {
            isFetching.value = true;
            const res = await LabelAPI.getLabels(undefined, q, q ? undefined : 50);
            labels.value = (res?.results ?? []);
            nMore.value = (res?.count - res?.results?.length) ?? 0;
            if (nMore.value > 0) {
                labels.value.push({
                    id: -1,
                    name: `and ${nMore.value} more...`,
                    color: '',
                    description: '',
                });
            }
            isFetching.value = false;
            return res;
        };
        onMounted(() => {
            fetchLabels('');
        });
        const handleSelect = async (id) => {
            emit('label-selected', labels.value.find(label => label.id === id));
        };
        const handleAddClick = async () => {
            inputHidden.value = false;
            nextTick(() => {
                inputElm.value?.focus();
            });
        };
        const handleVisibleChange = (visible) => {
            newLabel.value = undefined;
            if (!visible)
                inputHidden.value = true;
        };
        return {
            isFetching,
            newLabel,
            labels,
            nMore,
            hidePlus,
            inputHidden,
            inputElm,
            currentLabelIds,
            handleSelect,
            fetchLabels,
            handleVisibleChange,
            handleAddClick,
        };
    }
});
